"use client"

import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { Toggle as TogglePrimitive } from "radix-ui"

import { cn } from "@/custolink-newdesign/lib/utils"

const toggleVariants = cva(
  "cl:inline-flex cl:items-center cl:justify-center cl:gap-2 cl:rounded-md cl:text-sm cl:font-medium cl:whitespace-nowrap cl:transition-[color,box-shadow] cl:outline-none cl:hover:bg-muted cl:hover:text-muted-foreground cl:focus-visible:border-ring cl:focus-visible:ring-[3px] cl:focus-visible:ring-ring/50 cl:disabled:pointer-events-none cl:disabled:opacity-50 cl:aria-invalid:border-destructive cl:aria-invalid:ring-destructive/20 cl:data-[state=on]:bg-accent cl:data-[state=on]:text-accent-foreground cl:dark:aria-invalid:ring-destructive/40 cl:[&_svg]:pointer-events-none cl:[&_svg]:shrink-0 cl:[&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: "cl:bg-transparent",
        outline:
          "cl:border cl:border-input cl:bg-transparent cl:shadow-xs cl:hover:bg-accent cl:hover:text-accent-foreground",
      },
      size: {
        default: "cl:h-9 cl:min-w-9 cl:px-2",
        sm: "cl:h-8 cl:min-w-8 cl:px-1.5",
        lg: "cl:h-10 cl:min-w-10 cl:px-2.5",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

function Toggle({
  className,
  variant,
  size,
  ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> &
  VariantProps<typeof toggleVariants>) {
  return (
    <TogglePrimitive.Root
      data-slot="toggle"
      className={cn(toggleVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Toggle, toggleVariants }
